<template>
  <div itemscope itemtype="http://schema.org/Thing">
    <div id="singleItemCarousel" class="carousel slide col-md-11"  data-interval="false">
      <div class="carousel-inner">
        <div v-for="(image,  index) in allImagesForPicture"  class="carousel-item text-center" :class="{ active: index === 0}" >
          <a href="#imagelightbox" @click="showLightbox( image.url )" data-toggle="modal" v-if="index == 0">
          <picture class="lazy-picture prop-1-1" ref="ksSingle"  >
            <source  :srcset="image.urlSecondPreview + '.avif'" type="image/avif" >
            <source  :srcset="image.urlSecondPreview + '.webp'" type="image/webp">
            <img class="d-block mx-auto mw-100" :src="image.urlSecondPreview" :alt="alternate" :title="getItemName()" itemprop="image" width="650" height="650">
          </picture>
          </a>
          <a href="#imagelightbox" @click="showLightbox( image.url )" data-toggle="modal" v-else>

          <picture class="lazy-picture prop-1-1 lazy-bootstrap"  @click="showLightbox(image.url)" >
            <source  :srcset="image.urlSecondPreview + '.avif'" type="image/avif" >
            <source  :srcset="image.urlSecondPreview + '.webp'" type="image/webp">
            <img class="d-block mx-auto mw-100" :data-src="image.urlSecondPreview" :alt="alternate" :title="getItemName()" itemprop="image" width="650" height="650">
          </picture>
          </a>
        </div>
      </div>
      <a class="carousel-control-prev click-helper" href="#singleItemCarousel" role="button" data-slide="prev" v-if="allImagesForPicture.length > 1">
        <span class="fa fa-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next click-helper" href="#singleItemCarousel" role="button" data-slide="next" v-if="allImagesForPicture.length > 1">
        <span class="fa fa-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <ol class="carousel-indicators">
      <template v-for="(image, index) in allImagesForPicture" v-if="allImagesForPicture.length > 1">
        <li data-target="#singleItemCarousel" :data-slide-to="index" :key="image.id" class="click-helper">
          <img :src="image.urlPreview" :alt="alternate" width="80" height="80" class="singleItemPreview"/>
        </li>
      </template>
    </ol>
  </div>
</template>
<script>
export default {


  props: {
    maxQuantity:
        {
          type: Number,
          default: 10
        },
    imageUrlAccessor:
        {
          type: String,
          default: "url"
        },
    itemId:{
      type: Number,
      default:null
    },
    alternate: {
      type: String,
      default: ""
    },
    webpPics:{
      type:Object
    }
  },

  data()
  {
    return {
      currentItem     : 0,
    };
  },

  mounted()
  {
    this.$nextTick(() =>
    {
      $("#singleItemCarousel").on('slide.bs.carousel', (ev) => {
        $('.lazy-bootstrap').each((index) => {
          $('.lazy-bootstrap')[index].children.forEach((elem) => {
            if (elem.tagName === "SOURCE" && elem.srcset.length <= 0)
            {
              elem.srcset = elem.dataset.srcset;
            }
            if (elem.tagName === "IMG" && elem.src.length <= 0 )
            {
              elem.src = elem.dataset.src;
            }
          });
        });
      });
    });
  },

  computed:
      {
        getWebpBigUrl()
        {
          if(this.webpPics !== null)
          {
            if (this.webpPics.Big.length > 0)
            {
              return this.webpPics.Big;
            }
          }
          return false;
        },
        getWebpMiddleUrl()
        {
          if(this.webpPics !== null)
          {
            if (this.webpPics.Middle.length > 0)
            {
              return this.webpPics.Middle;
            }
          }
          return false;
        },

        currentVariation() {
          return this.$store.getters[`${this.$props.itemId}/currentItemVariation`]
        },
        allImagesForPicture()
        {
          let images;
          if (this.currentVariation.images.variation.length > 0)
          {
            images = this.currentVariation.images.variation;
          }
          else
          {
            images = this.currentVariation.images.all;
          }
          return images.slice(0, this.maxQuantity);
        }
      },


  methods:
      {
        getItemName()
        {
          return this.$options.filters.itemName(this.currentVariation);
        },
        showLightbox( x )
        {
          $(".modal-big-image").attr("src", x);
        }
      }
}
</script>
